var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlaySmSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3D900",
    fill: "#E3D900",
    strokeWidth: 3,
    d: "M1.5 1.5h77v77h-77z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39.648L26 26v28zm0 0",
    fill: "#170F4F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIxLjUiIHk9IjEuNSIgd2lkdGg9Ijc3IiBoZWlnaHQ9Ijc3IiBzdHJva2U9IiNFM0Q5MDAiIGZpbGw9IiNFM0Q5MDAiIHN0cm9rZS13aWR0aD0iMyIgLz4KICA8cGF0aCBkPSJNIDU0IDM5LjY0ODQzOCBMIDI2IDI2IEwgMjYgNTQgWiBNIDU0IDM5LjY0ODQzOCIgZmlsbD0iIzE3MEY0RiIgLz4KPC9zdmc+Cgo=";
export { SvgIconPlaySmSolid as ReactComponent };